import React, {useEffect, useState, useRef, useCallback} from 'react'
import {db} from '../..'
import {ref, onValue} from 'firebase/database'
import { useLocation } from 'react-router-dom'
import Loading from '../components/Loading'
import { Link } from 'react-router-dom'
import BottomMenu from './components/BottomMenu'
import Paging from './components/Paging'

const Missions = ({userData}) => {
  const location = useLocation();
  const { gameId, teamId } = location.state;

  const [missions, setMissions] = useState([]);
  const [timeLeft, setTimeLeft] = useState({});
  const [loading, setLoading] = useState(true);
  const missionInterval = useRef(null);

  // 終了済みミッション用のページング状態
  const [completedMissions, setCompletedMissions] = useState([]); // 終了済みミッション（現在のページ）
  const [allCompletedMissions, setAllCompletedMissions] = useState([]); // 全終了済みミッション
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [completedLoading, setCompletedLoading] = useState(false);
  const ITEMS_PER_PAGE = 8;

  // 終了済みミッションの指定ページを読み込む
  const loadCompletedMissionsPage = useCallback((pageNumber, allMissions) => {
    setCompletedLoading(true);

    const startIndex = (pageNumber - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const pageData = allMissions.slice(startIndex, endIndex);

    setCompletedMissions(pageData);
    setCurrentPage(pageNumber);
    setCompletedLoading(false);
  }, []);

  // ミッションデータ取得
  useEffect(() => {
    const missionsRef = ref(db, 'gameLogs/' + gameId + '/missions');

    const unsubscribe = onValue(missionsRef, (snapshot) => {
      if(snapshot.exists()) {
        const allMissions = [];
        const activeMissions = [];
        const finishedMissions = [];

        Object.keys(snapshot.val()).forEach((key) => {
          // チームのミッション達成状況
          let missionDone = false;
          if(snapshot.val()[key].reports) {
            if(snapshot.val()[key].reports[teamId]) {
              missionDone = true;
            }
          }

          const missionData = {
            ...snapshot.val()[key],
            done: missionDone,
            key: key
          };

          // 終了日時で発令中と終了済みを分離
          if(new Date(missionData.deadline) >= new Date()) {
            activeMissions.push(missionData);
          } else {
            finishedMissions.push(missionData);
          }

          allMissions.push(missionData);
        });

        // 発令中ミッション（従来通り）
        setMissions(activeMissions);

        // 終了済みミッション（新しい順にソート）
        const sortedFinishedMissions = finishedMissions.sort((a, b) => new Date(b.deadline) - new Date(a.deadline));
        setAllCompletedMissions(sortedFinishedMissions);
        setTotalPages(Math.ceil(sortedFinishedMissions.length / ITEMS_PER_PAGE));
        
        // 初回ページの読み込み
        loadCompletedMissionsPage(1, sortedFinishedMissions);

        setLoading(false);
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [gameId, teamId, loadCompletedMissionsPage]);

  // ページ変更時の処理
  const changePage = (changedNum) => {
    if(currentPage + changedNum < 1) return;
    if(currentPage + changedNum > totalPages) return;

    loadCompletedMissionsPage(currentPage + changedNum, allCompletedMissions);
  };

  // 残り時間の計算
  const calcTimeLeft = useCallback((index, time) => {
    if(!index && !time) return;
    const now = new Date().getTime();
    const endTime = new Date(time).getTime();
    const timeLeft = endTime - now;
    // console.log(timeLeft);

    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
  }, []);

  const repeatSet = useCallback(() => {
    const timeLeftTmp = {};
    missions.forEach((mission, index) => {
      if(mission.deadline) {
        timeLeftTmp[mission.key] = calcTimeLeft(mission.key, mission.deadline);
      }
    });
    setTimeLeft(timeLeftTmp);
  }, [missions, calcTimeLeft]);

  useEffect(() => {
    // インターバルがあればクリア
    if(missionInterval.current) {
      clearInterval(missionInterval.current);
      missionInterval.current = null;
    }

    // ミッションがあればインターバルをセット
    if(missions[0]) {
      repeatSet();
      missionInterval.current = setInterval(() => {
        repeatSet();
      }, 1000);
    }
  }, [missions, repeatSet]);

  return (
    <div className='max-w-6xl mx-auto my-6'>
        <Loading show={loading} text="ミッションを読込み中…" />
        <h1 className='text-2xl mb-3 mx-4 text-center'>ミッション</h1>

        <div className='m-2 lg:grid lg:grid-cols-2'>
            <div className='rounded-xl p-4 text-center m-2 bg-purple-50 border-purple-300 border shadow-sm'>
                <div className='text-purple-800 text-lg mb-3'>発令中！</div>
                
                {/* 発令中のミッション */}
                {
                  (missions && timeLeft) && missions.filter(mission => new Date(mission.deadline) >= new Date()).sort((a, b) => new Date(a.deadline) - new Date(b.deadline)).map((mission, index) => (
                    <Link to={'/game/missions/' + (mission.done ? 'view' : 'submit')} state={{gameId: gameId, teamId: teamId, missionId: mission.key}} key={index} className='block text-left rounded-lg bg-white shadow-sm p-2 mb-2 border border-gray-300 hover:bg-gray-50 cursor-pointer relative' >
                        <div className='text-base py-1.5 ps-10 me-24'>{mission.name}</div>
                        <div className='text-lg absolute end-3 top-2 text-purple-800 play-regular flex items-center py-0.5'>
                          <span >{timeLeft ? timeLeft[mission.key] : null}</span>
                        </div>
                        {
                          mission.done ? (
                            <div className='absolute top-2.5 start-3 text-2xl text-lime-500'><i className='bi bi-check-square-fill'></i></div>
                          ) : (
                            <div className='absolute top-2.5 start-3 text-2xl text-gray-300'><i className='bi bi-square'></i></div>
                          )
                        }
                    </Link>
                  ))
                }

                {
                  (missions && missions.filter(mission => new Date(mission.deadline) >= new Date()).length === 0) && (
                    <div className='text-gray-400'>発令中のミッションはありません</div>
                  )
                }
            </div>

            <div className='rounded-xl p-4 text-center m-2'>
                <div className='text-purple-800 text-lg mb-3'>終了済み</div>
                
                {completedLoading ? (
                    <div className='text-gray-400'>読み込み中...</div>
                ) : (
                    <>
                        {/* ページング */}
                        {totalPages > 1 && (
                            <div className='mt-4'>
                                <Paging changePage={changePage} currentPage={currentPage} totalPages={totalPages} />
                            </div>
                        )}

                        {
                          completedMissions && completedMissions.map((mission, index) => (
                            <Link to='/game/missions/view' state={{gameId: gameId, teamId: teamId, missionId: mission.key}} key={index} className='block text-left rounded-lg bg-purple-50 shadow-sm p-2 mb-2 border border-gray-300 hover:bg-gray-100 cursor-pointer relative'>
                                <div className='text-base py-1 ps-8'>{mission.name}</div>
                                {
                                  mission.done ? (
                                    <div className='absolute top-2 start-3 text-xl text-lime-500'><i className='bi bi-check-square-fill'></i></div>
                                  ) : (
                                    <div className='absolute top-2 start-3 text-xl text-gray-300'><i className='bi bi-square'></i></div>
                                  )
                                }
                            </Link>
                          ))
                        }
                        
                        {completedMissions && completedMissions.length === 0 && (
                            <div className='text-gray-400'>終了済みのミッションはありません</div>
                        )}
                        
                        {/* ページング */}
                        {totalPages > 1 && (
                            <div className='mt-4'>
                                <Paging changePage={changePage} currentPage={currentPage} totalPages={totalPages} />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>

        {/* 下部固定メニュー */}
        <BottomMenu gameId={gameId} teamId={teamId} />
    </div>
  )
}

export default Missions